/* Klaviyo signup popup — segmenting two-step capture.
   Step 1: Homeowner / Pro path choice (sets target list).
   Step 2: email -> Klaviyo client subscriptions API (public key, no secret).
   Pros are routed to the Trade Professionals list and offered /pages/trade.

   Trigger: 14s dwell OR 55% scroll, whichever first. Suppressed 30 days
   after close, 365 after signup (localStorage). Never on /pages/trade
   (its own form), cart, or password page. */

(function () {
  var COMPANY_ID = 'ShQMUX';
  var LISTS = { retail: 'YpXfv9', trade: 'TymT85' };
  var SUPPRESS_KEY = 'vl_kpop';
  var DAY = 86400000;

  var root = document.getElementById('KlaviyoPopup');
  if (!root) return;

  // Suppression + page exclusions
  var path = window.location.pathname;
  if (/\/pages\/trade|\/cart|\/challenge|\/password/.test(path)) return;
  try {
    var s = JSON.parse(localStorage.getItem(SUPPRESS_KEY) || 'null');
    if (s && Date.now() < s.until) return;
  } catch (e) {}

  var state = { list: LISTS.retail, source: 'popup-homeowner' };

  function open() {
    if (root.classList.contains('is-open')) return;
    root.classList.add('is-open');
  }

  function close(days) {
    root.classList.remove('is-open');
    try {
      localStorage.setItem(SUPPRESS_KEY, JSON.stringify({ until: Date.now() + days * DAY }));
    } catch (e) {}
  }

  // Trigger. Pure dwell: the popup opens only after a full minute on site, and
  // never in response to scrolling. History: a percentage-only scroll trigger
  // used to fire within ~3s on mobile (PDP lazy-loads images, so first-paint
  // scrollHeight is short and a single flick-scroll cleared the threshold),
  // ambushing fresh visitors before they saw the product (94% mobile bounce on
  // paid traffic, 2026-06-30). Fixing the timing dropped paid mobile bounce to
  // ~37%. We now hold to a single 60s dwell so a genuine browser gets the
  // invite and a bouncing visitor never sees it. No scroll listener at all.
  setTimeout(open, 60000);

  // Wiring
  var step1 = root.querySelector('[data-kpop-step1]');
  var step2 = root.querySelector('[data-kpop-step2]');
  var success = root.querySelector('[data-kpop-success]');
  var form = root.querySelector('[data-kpop-form]');
  var emailInput = root.querySelector('[data-kpop-email]');
  var errEl = root.querySelector('[data-kpop-error]');
  var step2Title = root.querySelector('[data-kpop-step2-title]');
  var successBody = root.querySelector('[data-kpop-success-body]');

  root.querySelectorAll('[data-kpop-close]').forEach(function (el) {
    el.addEventListener('click', function () { close(30); });
  });

  root.querySelectorAll('[data-kpop-path]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var isTrade = btn.getAttribute('data-kpop-path') === 'trade';
      state.list = isTrade ? LISTS.trade : LISTS.retail;
      state.source = isTrade ? 'popup-pro' : 'popup-homeowner';
      step2Title.textContent = isTrade
        ? 'Spec sheets, finish drops, and trade pricing news.'
        : 'New fixtures and finish drops. No noise.';
      step1.classList.add('kpop__hidden');
      step2.classList.remove('kpop__hidden');
      emailInput.focus();
    });
  });

  root.querySelector('[data-kpop-back]').addEventListener('click', function () {
    step2.classList.add('kpop__hidden');
    step1.classList.remove('kpop__hidden');
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (emailInput.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      errEl.textContent = 'Enter a valid email address.';
      errEl.classList.remove('kpop__hidden');
      return;
    }
    errEl.classList.add('kpop__hidden');
    var btn = form.querySelector('button[type="submit"]');
    btn.disabled = true;

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: state.source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { audience: state.source === 'popup-pro' ? 'trade' : 'retail' }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: state.list } } }
        }
      })
    }).then(function (res) {
      if (!res.ok && res.status !== 202) throw new Error('subscribe failed ' + res.status);
      step2.classList.add('kpop__hidden');
      if (state.source === 'popup-pro') {
        successBody.innerHTML = 'You’re on the list. While you’re here: trade accounts get flat pricing, Net-30, and spec files on every fixture. <a href="/pages/trade">Apply in two minutes</a>.';
      }
      success.classList.remove('kpop__hidden');
      try { localStorage.setItem(SUPPRESS_KEY, JSON.stringify({ until: Date.now() + 365 * DAY })); } catch (err) {}
    }).catch(function () {
      btn.disabled = false;
      errEl.textContent = 'Something went wrong. Try again.';
      errEl.classList.remove('kpop__hidden');
    });
  });
})();
